export default "<div class=\"markdown-viewer\" ng-bind-html=\"$ctrl.html\"></div>\r\n";